import { Head } from '@src/generic';

import {
  HomeHeroSection,
  HomePartnersSection,
  HomeRecentCoursesSection,
  HomeStepsSection,
  HomeTestimonialsSection,
} from './components/jiltarjih-home/JilTarjihHomeSections';

const HomePage = () => (
  <>
    <Head />
    <main className="jiltarjih-homepage">
      <HomeHeroSection />
      <HomeStepsSection />
      <HomeRecentCoursesSection />
      <HomePartnersSection />
      <HomeTestimonialsSection />
    </main>
  </>
);

export default HomePage;
